import { ProductCard as CartProductCard, GiveawayCard as CartGiveawayCard } from './Cart';
import { ProductCard as OrderProductCard, RefundCard as OrderRefundCard } from './Order';
import { ProductCardSkeleton } from './ProductCardSkeleton';

export const ProductCard = {
    Cart: CartProductCard,
    CartGiveaway: CartGiveawayCard,
    Order: OrderProductCard,
    OrderRefund: OrderRefundCard,
    Skeleton: ProductCardSkeleton,
};
